import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { PublicTokenResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  url = environment.authService;

  constructor(private httpClient: HttpClient) {}

  getAuthToken(): Observable<PublicTokenResponse> {
    return this.httpClient.post<PublicTokenResponse>(this.url, {
      service: '9370afad-59c4-4ad9-867d-a8ad2502068f',
    });
  }
}
